import { Component, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { NavController, ModalController, ToastController } from '@ionic/angular';
import { PouchService } from '../../services/pouch-service';
import { FileViewerPage } from 'src/app/fileviewer/fileviewer';
declare let firebase: any;

@Component({
  selector: 'page-comment',
  templateUrl: './comment.html',
  styleUrls: ['comment.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommentPageComponent {
  @Input() entity: any;
  @Input() item: any;
  @Input() mode: any;
  comment = '';

  constructor(public db: PouchService, public modalCtrl: ModalController, public navCtrl: NavController, public toastController: ToastController) {}

  async ngOnChanges(changes: SimpleChanges) {
    Object.keys(changes).map((key) => {
      if (changes[key].currentValue != undefined) {
        this[key] = changes[key].currentValue;
      }
    });
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  addComment(item, file = '') {
    //error check
    if (this.entity[item] == undefined || this.entity[item] == '') {
      this.entity[item] = [];
    }
    this.entity[item].unshift({
      id: Math.round(new Date().getTime()).toString(),
      date: this.db.localDate(),
      user: this.db.user.fullname,
      comment: this.comment,
      file: file,
    });
    this.comment = '';
    this.db.update(this.entity, this.mode).then((entity) => {
      this.presentToast('Comment Added Successfully', 'toast-success');
      //this.getImageAttachments(); commented out as you cannot load this from a component page like task page without gounf through @Input() route
    });
  }

  viewFile(item) {
    this.db.getAttachment(this.mode, this.entity.id, item).then(async (attachment) => {
      let modal = await this.modalCtrl.create({
        component: FileViewerPage,
        componentProps: { attachment: attachment, name: item },
      });
      modal.onDidDismiss().then((res) => {
        /* if (res.data != undefined) {
            this.entity[item] = res.data;
          } */
      });
      return await modal.present();
    });
  }

  fileListener(files: FileList, item, iscomment = false) {
    Array.from(files).forEach((file) => {
      if (file != undefined) {
        if (this.entity.attachments == undefined) {
          this.entity.attachments = {};
        }
        this.entity.attachments[file.name] = {
          type: file.type,
          data: file,
          name: file.name,
          content_type: file.type,
          iscomment: iscomment, //to know whether to filter it and show close to comments
        };
        if (iscomment) {
          this.addComment(item, file.name);
        } else {
          this.db.update(this.entity, this.mode).then((entity) => {
            this.presentToast('File saved Successfully', 'toast-success');
            //this.getImageAttachments(); commented out as you cannot load this from a component page like task page without gounf through @Input() route
          });
        }
        document.getElementById('commentfileinput')['value'] = null;
      }
    });
  }
}
